import { render } from "./termUse.vue?vue&type=template&id=5795188a&scoped=true"
import script from "./termUse.vue?vue&type=script&lang=js"
export * from "./termUse.vue?vue&type=script&lang=js"

import "./termUse.vue?vue&type=style&index=0&id=5795188a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5795188a"]])

export default __exports__